import React, { Fragment, useContext } from 'react';
import { Container, Row } from 'reactstrap';
import GalleryContext from '../../../_helper/Gallery';
import ListOfImage from './ListOfImages';

const ImageGalleryContain = () => {

  const { smallImages } = useContext(GalleryContext);

  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <ListOfImage smallImages={smallImages} />
        </Row>
      </Container>
    </Fragment>
  );
};

export default ImageGalleryContain;